import styled from '@emotion/styled';

export const MainWrapper = styled.div`
  width: 100%;
  font-size: 14px;
  color: #909090;
  background-color: #fff;
  font-family: NotoSansKR, 'Noto Sans Thai', sans-serif;
  overflow-wrap: break-word;
  word-break: break-all;
  padding-bottom: 80px;

  h3 {
    //장
    color: #131415;
    font-size: 20px;
    font-weight: bold;
  }

  p {
    //조
    font-size: 14px;
    font-weight: bold;
    margin-top: 40px;
    margin-bottom: 20px;
    color: #4b4b4b;
  }

  ol {
    //항 : 원형 안의 숫자 (text로 사용)
    //호 : 일반 숫자
    list-style-type: decimal;
    font-size: 14px;
    line-height: 1.43;
    word-break: break-all;

    > li {
      margin-left: 28px;

      > ol {
        list-style-type: disc;
        > li {
          // 목 : 일반 리스트 점
          /* list-style: inside; */
          margin-left: 16px;
        }
      }
    }
  }

  ol > li:first-child {
    margin-top: 20px;
  }
  ol > li:last-child {
    margin-bottom: 20px;
  }

  ol > li > ol > li:first-child {
    margin-top: 4px;
  }

  .table-wrapper {
    margin: 20px auto;
    width: 600px;
    overflow-y: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  table {
    width: 600px;
    margin-bottom: 0;
    border-bottom: 1px solid #d8d8d8;
  }

  th {
    color: #bcbcbc;
  }

  table,
  th,
  td {
    border-top: 1px solid #d8d8d8;
    border-collapse: collapse;
    text-align: center;
    padding: 20px;
    font-size: 12px;
  }

  td {
    color: #4b4b4b;
  }

  @media screen and (max-width: 600px) {
    .table-wrapper {
      width: 80vw;
    }
  }
`;
